export const convertToTypeState = (supportedFileTypes) => {
    const acceptedTypes = [...new Set(supportedFileTypes.map((item) => item.fileType))];
    const fileExtensions = [
        ...new Set(supportedFileTypes.map((item) => item.extensions).reduce((array, item) => array.concat(item), [])),
    ];
    const acceptedTypesAsString = acceptedTypes.join(', ');
    const fileExtensionsAsString = fileExtensions.map((item) => `.${item}`).join(', ');
    return {
        acceptedTypes,
        acceptedTypesAsString,
        fileExtensions,
        fileExtensionsAsString,
    };
};
//# sourceMappingURL=utils.js.map